import styled from "styled-components";

import Button from "core/Button";

import colors from "core/colors";

import { convertPxToRem } from "frontend/components/helpers";

export const CopyButton = styled(Button)`
    min-width: ${({ darkMode }) =>
        darkMode ? convertPxToRem({ px: 97 }) : convertPxToRem({ px: 72 })};
`;

export const AttributionFormContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid
        ${({ darkMode }) =>
            darkMode ? colors.primary.moon : colors.secondary.manatee};
    border-radius: 4px;
    padding: ${convertPxToRem({ px: 16 })} ${convertPxToRem({ px: 12 })};
    margin-top: ${({ darkMode }) =>
        darkMode ? convertPxToRem({ px: 16 }) : convertPxToRem({ px: 24 })};

    ${({ darkMode }) =>
        !darkMode && `background-color: ${colors.primary.snow}`};

    ${CopyButton} {
        margin-left: ${({ darkMode }) =>
            darkMode ? convertPxToRem({ px: 8 }) : convertPxToRem({ px: 10 })};
    }
`;
